import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { converter } from '../../../../helpers/converter';

export default class PurchaseButton extends Component {
  static propTypes = {
    button: PropTypes.object,
    metadata: PropTypes.object,
    purchaseInfo: PropTypes.object,
    translations: PropTypes.object,
    params: PropTypes.object,
    onClickPurchase: PropTypes.func,
  };

  constructor(props) {
    super(props);
  }

  handleClick = () => {
    const { onClickPurchase, button } = this.props;
    onClickPurchase(button);
  };

  render() {
    const { button, metadata, translations, params, purchaseInfo } = this.props;

    if (
      button.startdate &&
      button.waspurchased &&
      purchaseInfo.playButton.visible !== '1'
    ) {
      if (metadata.live_ppe_available) {
        try {
          const ppeAva = JSON.parse(metadata.live_ppe_available);
          const liveLabel = converter.convertApaUnicode(
            translations,
            ppeAva[params.id],
            'Disponible Pronto',
          );
          return (
            <button className="btn btn-default btn-lg">{liveLabel}</button>
          );
        } catch (e) {
          return null;
        }
      }
    }

    if (button.waspurchased) {
      return null;
    }

    return (
      <button
        className="btn btn-default btn-lg primary"
        key={`btn-purchase-${button.offerid}`}
        onClick={this.handleClick}
      >
        <span className="">
          {`${button.oneofferdesc}  ${button.currency}${button.price}`}
        </span>
      </button>
    );
  }
}
